export default __webpack_public_path__ + "static/media/tracking-realized-ico.c500dfb2.svg";